"use client";

import Link from "next/link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export default function NotFound() {
  return (
    <Box
      component="section"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "100vh",
        px: 2,
        bgcolor: "background.default",
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: "4rem", md: "6rem" },
          color: "primary.main",
        }}
      >
        404
      </Typography>
      <Typography variant="h4" mt={2} mb={1}>
        Üzgünüz, sayfa bulunamadı
      </Typography>
      <Typography variant="body1" mb={4} maxWidth={400}>
        Aradığın sayfa taşınmış veya hiç var olmamış olabilir. Anasayfaya dönüp
        koleksiyonları keşfedebilirsin.
      </Typography>
      <Button
        variant="contained"
        component={Link}
        href="/"
        sx={{ textTransform: "none" }}
      >
        Anasayfaya Dön
      </Button>
    </Box>
  );
}
